function formatNumber(num) {
    if (num % 1 === 0) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } else {
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
  }

export { formatNumber };